import "./css/root.css"
import "./css/reset.css"
import "./css/utils.css"
import "./css/typography.css"
import "./css/layout.css"
import "./css/buttons.css"
import "./css/details.css"
import "./css/icons.css"

import "./css/blocks.css"
import "./css/mood.css"
import "./css/grid.css"
import "./css/header.css"
import "./css/footer.css"
import "./css/timeline.css"
import "./css/articles.css"
import "./css/partners.css"
import "./css/persons.css"
import "./css/download.css"
import "./css/form.css"
import "./css/boxes.css"
import "./css/cta.css"

import { setDetailsHeights } from "./js/details"
import { copyToClipboard, onReady } from "./js/utils"

window.htmx = require("htmx.org")

function toggles() {
  document.body.addEventListener("click", (e) => {
    const controller = e.target?.closest("[aria-controls]")
    const targetId = controller
      ? controller.getAttribute("aria-controls")
      : undefined
    const target = targetId ? document.querySelector(`#${targetId}`) : undefined
    if (controller && target) {
      if (targetId === "expanded-main-nav") {
        window._toggleStates[targetId] = !window._toggleStates[targetId]
        document.body.classList.toggle(
          `${targetId}-open`,
          window._toggleStates[targetId],
        )
      } else if (targetId === "banner") {
        window.localStorage.setItem("banner", target.dataset.bannerHash)
        target.style.display = "none"
      }
    }
  })
}

function showBanner() {
  const banner = document.getElementById("banner")
  if (
    banner &&
    window.localStorage.getItem("banner") !== banner.dataset.bannerHash
  )
    banner.style.display = "block"
}

showBanner()

function scrolledBody() {
  function handleScroll() {
    document.body.classList.toggle("scrolled", window.scrollY > 10)
  }
  handleScroll()
  window.addEventListener("scroll", handleScroll, { passive: true })
}

const obs = new IntersectionObserver((entries) => {
  entries.forEach((e) => {
    if (e.isIntersecting) {
      e.target.classList.add("visible")
    }
  })
})

function setupCopyButtons() {
  document.body.addEventListener("click", (e) => {
    const copyButton = e.target?.closest(".copy-link")
    if (copyButton) {
      const url = copyButton.getAttribute("data-copy-url")
      if (url) {
        copyToClipboard(url).then((success) => {
          if (success) {
            copyButton.classList.add("copied")
            setTimeout(() => {
              copyButton.classList.remove("copied")
            }, 2000)
          }
        })
      }
    }
  })
}

for (const el of document.querySelectorAll(".main .container")) {
  obs.observe(el)
}

window._toggleStates = {}
onReady(toggles)
onReady(scrolledBody)
onReady(setDetailsHeights("details"))
onReady(setupCopyButtons)

const cl = document.documentElement.classList
cl.remove("no-js")
cl.add("js")
